/* eslint-disable jira/filename-case */
import React from 'react';

/**
 * we inject React as a global to support libraries that expect it to be available globally,
 * for example cases when classic jsx transform was used where modern one was expected
 */
globalThis.React = React;
